import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import {
  createNewTopic,
  getUserChatTopicListWithFilter,
} from '@app/adapter/chat-service';
import { loggedInUserState } from '@app/domain/app';
import { organization } from '@app/domain/organization';
import { isError } from '@app/utils/error';
import { useSetSnackbar } from '@app/utils/useSetSnackbar';

/**
 * 対象ユーザーとのチャット詳細画面を開くフック
 * Topicが既に存在すればそのTopicへ、なければTopicを作成した上で遷移する
 */
export function useOpenChatWithUser() {
  const navigate = useNavigate();
  const setSnackbar = useSetSnackbar();
  const loggedInUser = useRecoilValue(loggedInUserState);
  const organizationState = useRecoilValue(organization);
  const [isOpeningChat, setIsOpeningChat] = useState(false);

  const openChatWithUser = useCallback(
    async (userId?: string) => {
      if (!loggedInUser?.id || !userId) return;
      setIsOpeningChat(true);
      try {
        const {
          data: { value: topics },
        } = await getUserChatTopicListWithFilter(loggedInUser.id, {
          filter: { ownerIds: [userId] },
          pageSize: 1,
        });
        const topic =
          topics[0] ||
          (
            await createNewTopic(
              loggedInUser.id,
              userId,
              organizationState.name
            )
          ).data;
        navigate(`/chats/${topic.id}`);
      } catch (e) {
        if (isError(e)) {
          console.error('openChatWithUser', e.message);
        }
        setSnackbar(true, 'チャットの取得に失敗しました', 'error');
      } finally {
        setIsOpeningChat(false);
      }
    },
    [loggedInUser, organizationState.name, navigate, setSnackbar]
  );

  return { isOpeningChat, openChatWithUser };
}
